import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import BeneAccountGridView from "../../../../components/Accounts/BeneAccount/BeneAccountGridView/index.jsx";
import BeneAccountListView from "../../../../components/Accounts/BeneAccount/BeneAccountListView/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import {
  addNewLabel,
  beneCategories,
  beneViewAllAcc,
  removeNewLabel,
  resetToggle,
  setToggle,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams.js";
import "./index.css";

const BeneficiaryAccountViewAll = ({
  id,
  type,
  typepop,
  onClosepop,
  handleButtonClick,
  internalAccount,
  associateAccount,
  associatepanNumber,
  associateIFSC,
  associateaccountNumber,
  setOpenBeneAssociate,
  beneAccountId,
  accountType,
  flow,
  setTxnPayLoad,
  txnPayLoad,
  setIsNeft,
  setIsImps,
  setIsRtgs,
  BeneTxnAssocAcct,
  setAssociateModalOpen,
  associateTxn,
  name1,
  handleClick,
  showModalPopup,
  subType,
  remPan,
  remAccount,
  remIFSC,
  onCardNavigate,
  accActiveInactiveState,
  activeInactivePan,
  activeInactiveFlow,
  activeInactiveIfsc,
  activeInactiveBank,
  setIsalertPopup,
  setFlowSelectedId,
  classifiedFlow = false,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const dateRef = useRef(null);
  const filterRef = useRef(null);
  const lastElementRef = useRef();
  const sidebarRefm = useRef(null);
  const dropdownRef = useRef(null);
  const dropdownRefm = useRef(null);
  const searchBarRefAcc = useRef(null);
  const searchBarRefAcc2 = useRef(null);
  const scrollContainerRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams, handleClearSearchParam } =
    useCustomSearchParams(
      location?.state &&
        location?.state?.approvalStatus &&
        location?.state?.approvalStatus !== "all"
        ? {
            status: location?.state?.approvalStatus,
            pageno: GlobalConfiguration.lengthCheckOne,
            pagesize: dropdownOptions[0],
          }
        : {
            pageno: GlobalConfiguration.lengthCheckOne,
            pagesize: dropdownOptions[0],
          },
    );
  const convertDate = (dateString) => {
    if (!dateString) return;
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );

    return timestamp;
  };

  const updatedStatus = location.state ? location.state.approvalStatus : "";
  const approvalStatus = typepop === "popup" ? "" : updatedStatus;

  const [active, setActive] = useState("");
  const [labels, setLabels] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [endDate, setEndDate] = useState(null);
  const [mainData, setMainData] = useState([]);
  const [isOpenm, setIsOpenm] = useState(false);
  const [Labeldata, setLabeldata] = useState([]);
  const [inputData, setInputData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [callFilter, setcallFilter] = useState(null);
  const [tempEndDate, setTempEndDate] = useState("");
  const [currentStatus, setCurrentStatus] = useState(
    searchParam.get("status") || approvalStatus || "",
  );
  const [initCategory, setInitCategory] = useState("");
  const [getFilterStatus, setFilterStatus] = useState();
  const [loadingData, setLoadingData] = useState(false);
  const [LabelAccounts, setLabelAccounts] = useState([]);
  const [tempStartDate, setTempStartDate] = useState("");
  const [searchPanText, setSearchPanText] = useState(
    associateAccount || associateTxn || BeneTxnAssocAcct
      ? associatepanNumber
      : "",
  );
  const [lableInput, setlableInput] = useState(false);
  const [balanceType, setBalanceType] = useState("Pan");
  const [accountNumber, setAccountNumber] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Bank" || activeInactiveFlow === "Existing")
      ? activeInactiveBank
      : searchParam.get("accno") || "",
  );
  const [searchUserText, setSearchUserText] = useState(
    searchParam.get("search") || "",
  );
  const [searchIfscText, setSearchIfscText] = useState("");
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [LabelSearchText, setLabelSearchText] = useState(
    searchParam.get("label")?.split(",") || [],
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isSidebarOpenm, setIsSidebarOpenm] = useState(false);
  const [showSearchBarm, setShowSearchBarm] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [searchAccountText, setSearchAccountText] = useState("");
  const [isWheelScrolling, setIsWheelScrolling] = useState(false);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const [showDataCountPopup, setShowDataCountPopup] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [isIfsc, setIsIfsc] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Bank" || activeInactiveFlow === "Existing")
      ? activeInactiveIfsc
      : searchParam.get("ifsc") || "",
  );
  const [panNumber, setPanNumber] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Pan" || activeInactiveFlow === "Existing")
      ? activeInactivePan
      : searchParam.get("pan") || "",
  );
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [currentCategory, setCurrentCategory] = useState(
    searchParam.get("category") || "",
  );
  const [startDateFilter, setStartDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[0]) || "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[1]) || "",
  );
  const filteredData = accumulatedData;
  const status =
    flow === "unassignCategory"
      ? ["approved", "pending", "rejected"]
      : ["approved", "pending", "rejected", "blocked", "archived"];

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const { services } = useSelector((state) => state.refreshToken);
  const { toggle } = useSelector((state) => state.beneAllVerification);

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const fetchSearchData = async () => {
    let response;
    let data = [];
    setLoadingData(true);

    switch (active) {
      case "Category":
        response = await dispatch(
          beneCategories({ search_string: searchUserTextDebounce }),
        );
        data = response?.payload?.categories?.map((itm) => {
          return {
            id: itm.name,
            Category: itm.name,
            Description: itm?.description || "Not given",
          };
        });
        setInputData(data);
        setLoadingData(false);
        break;
      case "Labels":
        data = labels
          ?.filter((itm) => {
            if (itm.includes(searchUserTextDebounce)) return itm;
          })
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        setLoadingData(false);
        break;
      default:
        break;
    }
  };

  async function fetchData() {
    setLoading(true);
    try {
      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
        ...(subType ? { reimbursement_account: "Y" } : {}),
        ...(type === "activeInactive" && {
          associate:
            type === "activeInactive" && accActiveInactiveState === "active"
              ? ["pending", "approved"]
              : type === "activeInactive" &&
                  accActiveInactiveState === "inactive"
                ? ["blocked", "archived", "rejected"]
                : undefined,
        }),
      };

      const addParamsBasedOnSelection = () => {
        if (currentStatus !== "all") {
          queryParams.approval_status = currentStatus;
        }
        if (currentCategory !== "") {
          queryParams.categoryName = currentCategory;
        }
        if (
          startDateFilter !== "" &&
          endDateFilter !== "" &&
          startDateFilter !== GlobalConfiguration?.lengthCheckZero &&
          endDateFilter !== GlobalConfiguration?.lengthCheckZero &&
          !isNaN(Number(startDateFilter)) &&
          !isNaN(Number(endDateFilter))
        ) {
          queryParams.start_date = startDateFilter;
          queryParams.end_date = endDateFilter;
        }

        if (accountNumber !== "" || remAccount) {
          queryParams.bank_account_no = remAccount ? remAccount : accountNumber;
        }

        if (isIfsc !== "" || remIFSC) {
          queryParams.ifsc = remIFSC
            ? remIFSC.toUpperCase()
            : isIfsc.toUpperCase();
        }

        if (panNumber !== "" || remPan) {
          queryParams.pan = remPan
            ? remPan.toUpperCase()
            : panNumber.toUpperCase();
        }

        if (searchUserText !== "") {
          queryParams.search_string = searchUserText;
        }
        if (LabelSearchText?.length !== GlobalConfiguration?.lengthCheckZero) {
          queryParams.labels = LabelSearchText;
        }
        if (
          internalAccount === "internalAccount" ||
          accountType === "internal" ||
          flow === "internalTxn" ||
          associateTxn === "associateTxn"
        ) {
          queryParams.type = "internalAccount";
        }
      };
      addParamsBasedOnSelection();

      const response = await dispatch(beneViewAllAcc(queryParams));
      const newData = response?.payload?.beneficiary_accounts || [];
      setMainData(response?.payload);
      setAccumulatedData(newData);
      setTotalCount(response?.payload?.total_count || 0);
      setLoading(false);
      setShowDataCountPopup(true);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
    setTimeout(() => {
      setShowDataCountPopup(false);
    }, IntervalConfiguration.intervalExtraLarger);
  }
  const onMount = () => {};

  const handlePagination = (page) => {
    handleSubmit("pageno", page);
    setCurrentPage(page);
    if (isLabelClicked) {
      setLabelAccounts([]);
    }
  };

  const handleDateChange = (dates) => {
    if (!dates) {
      setStartDate(null);
      setEndDate(null);
      setStartDateFilter("");
      setEndDateFilter("");
      return;
    }

    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    if (start && end) {
      const startTimestamp = Math.floor(start.getTime() / 1000);
      const endTimestamp = Math.floor(end.getTime() / 1000);
      setStartDateFilter(startTimestamp);
      setEndDateFilter(endTimestamp);
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };
  const handleClearFilters = () => {
    setInitCategory("");
    setCurrentCategory("");
    setShowDatePicker(false);
    setStartDate(null);
    setEndDate(null);
    setTempEndDate("");
    setTempStartDate("");
    setStartDateFilter("");
    setEndDateFilter("");
    setCurrentCategory("");
    setAccountNumber("");
    setSearchAccountText("");
    setShowSearchBar(false);
    setShowSearchBarm(false);
    setSearchIfscText("");
    setSearchUserText("");
    setIsIfsc("");
    setLabelSearchText([]);
    setSelectedLabels([]);
    setisLabelClicked(false);
    setCurrentStatus("");
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setSearchUserTextDebounce("");
    if (
      (associateAccount ||
        BeneTxnAssocAcct ||
        associateTxn === "associateTxn") &&
      balanceType === "Pan"
    ) {
      setSearchPanText(searchPanText);
      setPanNumber(panNumber);
    } else if (balanceType === "Bank") {
      setAccountNumber(accountNumber);
      setSearchAccountText(searchAccountText);
      setSearchIfscText(searchIfscText);
      setPanNumber("");
      setSearchPanText("");
    } else {
      setSearchPanText("");
      setPanNumber("");
    }
    if (type === "activeInactive" && activeInactiveFlow === "Pan") {
      setPanNumber(activeInactivePan);
    } else if (type === "activeInactive" && activeInactiveFlow === "Bank") {
      setAccountNumber(activeInactiveBank);
      setIsIfsc(activeInactiveIfsc);
    } else if (activeInactiveFlow === "Existing") {
      setPanNumber(activeInactivePan);
      setAccountNumber(activeInactiveBank);
      setIsIfsc(activeInactiveIfsc);
    }
  };

  const handleSubmit = (key, value) => {
    if (typepop !== "popup" && type !== "activeInactive") {
      handleSearchParams(key, value);
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const res = await dispatch(
      addNewLabel({
        record_ids: toArray(LabelAccounts),
        labels: labelsToAssign,
      }),
    );

    if (addNewLabel?.fulfilled?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (addNewLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
    if (addNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const res = await dispatch(
      removeNewLabel({
        record_ids: toArray(LabelAccounts),
        labels: labelsToUnassign,
      }),
    );

    if (removeNewLabel?.fulfilled?.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeNewLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
    if (removeNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleToggle = (newToggleValue) => {
    if (toggle !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({ top: 0, behavior: "smooth" });

      if (!showSearchBar && !isSidebarOpen) {
        dispatch(setToggle(newToggleValue));
      }
    }
  };

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    toggleDropdown();
  };

  const handleKeyDown = useCallback((event) => {
    const activeElement = document.activeElement;
    const isTyping =
      activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA";

    if (
      !isTyping &&
      (event.key.toLowerCase() === "w" ||
        event.key.toLowerCase() === "s" ||
        event.key === "ArrowUp" ||
        event.key === "ArrowDown")
    ) {
      event.preventDefault();
      setIsWheelScrolling(false);
    }
  }, []);

  const handleWheel = useCallback((event) => {
    setIsWheelScrolling(true);
  }, []);

  const handleSelectAll = () => {
    const filteredItems = filteredData.filter(
      (item) => item?.approval_status !== "archived",
    );

    const allIds = filteredItems.map((item) => item.id);
    setLabelAccounts((prev) => {
      const isPageFullySelected = allIds.every((id) => prev.includes(id));

      if (isPageFullySelected) {
        return [];
      } else {
        return [...allIds];
      }
    });
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);
    if (labelActionDispatchedRef.current) {
      fetchData();
      setLabelAccounts([]);
      setisLabelClicked(false);
      setShowSearchBar(false);
      setSearchUserText("");
      setSearchTerm("");
      setCurrentPage(GlobalConfiguration.lengthCheckOne);
    }
  };

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      !!(startDateFilter && endDateFilter) ||
        (currentStatus !== "all" && !!currentStatus),
    );
  };

  const isFilterActive =
    currentCategory !== "" ||
    panNumber !== "" ||
    accountNumber !== "" ||
    isIfsc !== "" ||
    LabelSearchText?.length !== GlobalConfiguration?.lengthCheckZero ||
    (startDateFilter &&
      endDateFilter &&
      startDateFilter !== GlobalConfiguration?.lengthCheckZero &&
      endDateFilter !== GlobalConfiguration?.lengthCheckZero &&
      !isNaN(Number(startDateFilter)) &&
      !isNaN(Number(endDateFilter)));

  const handleClickOutside = (event) => {
    if (event.target.className == "acc_black_div") {
      setIsSidebarOpen(false);
    } else {
    }

    if (sidebarRefm.current && !sidebarRefm.current.contains(event.target)) {
      setIsSidebarOpenm(false);
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchSearchData();
    }
  }, [active]);

  useEffect(() => {
    dispatch(enableSwitcher());
    onMount();
    return () => {
      dispatch(setToggle(false));
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    onMount();
  }, [markerData]);

  useEffect(() => {
    if (isLabelClicked) {
      dispatch(disableSwitcher());
    } else {
      dispatch(enableSwitcher());
    }
  }, [isLabelClicked]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBarRefAcc.current &&
        !searchBarRefAcc.current.contains(event.target) &&
        searchBarRefAcc2.current &&
        !searchBarRefAcc2.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }

      if (
        filterRef.current &&
        !filterRef.current.contains(event.target) &&
        !(dateRef.current && dateRef.current.contains(event.target))
      ) {
        setShowDatePicker(false);
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }

      if (
        dropdownRefm.current &&
        !dropdownRefm.current.contains(event.target)
      ) {
        setIsOpenm(false);
      }

      if (
        dropdownRefm.current &&
        !dropdownRefm.current.contains(event.target)
      ) {
        setIsOpenm(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (callFilter) {
      callFilter();
    }
  }, [balanceType]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("wheel", handleWheel);
    };
  }, [handleKeyDown, handleWheel]);

  useEffect(() => {
    fetchData();
    let availableLabels = sessionStorage?.getItem("AvailableLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [
    currentPage,
    currentStatus,
    currentCategory,
    searchUserText,
    startDateFilter,
    endDateFilter,
    accountNumber,
    pageSize,
    panNumber,
    isIfsc,
    associateIFSC,
    associateaccountNumber,
    associatepanNumber,
    LabelSearchText,
    remAccount,
    remIFSC,
    remPan,
    accActiveInactiveState,
  ]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isSidebarOpen, getFilterStatus]);

  useEffect(() => {
    if (isSidebarOpenm) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarOpenm, getFilterStatus]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [
    currentCategory,
    startDateFilter,
    endDateFilter,
    accountNumber,
    panNumber,
    isIfsc,
    currentStatus,
  ]);

  useEffect(() => {
    if (startDateFilter && endDateFilter && !startDate && !endDate) {
      const start = new Date(
        startDateFilter * IntervalConfiguration.intervalMedium,
      );
      const end = new Date(
        endDateFilter * IntervalConfiguration.intervalMedium,
      );
      setStartDate(start);
      setEndDate(end);
    }
  }, [startDateFilter, endDateFilter]);

  useEffect(() => {
    if (typepop === "popup" || type === "activeInactive") {
      dispatch(resetToggle());
    }
  }, []);

  useEffect(() => {
    if (filterRef.current) {
      filterRef.current.scrollTo({
        top: GlobalConfiguration?.lengthCheckZero,
      });
    }
  }, [toggle, currentPage, accumulatedData]);

  return (
    <>
      <div
        className={`bg-primary-bg flex flex-col ${typepop === "popup" || type === "activeInactive" ? "flex-1 overflow-hidden h-height-full" : "h-full-height"} `}
        style={{
          position: "relative",
          overflow: "hidden",
          width:
            typepop === "popup" || type === "activeInactive"
              ? ""
              : "var(--full-width)",
        }}
      >
        {(isPopoverOpen || isSidebarOpen) && (
          <div className="acc_black_div"></div>
        )}

        <div
          className={`absolute bg-primary-nav ${isSidebarOpen || showInnerSearchBar ? "z-z-index-content pointer-events-none" : "z-z-index-dropdown"} shadow-box-shadow-top ${
            typepop === "popup" || type === "activeInactive"
              ? "w-full Qmd:w-full-popup-width rounded-none bottom-bottom-base"
              : "bottom-bottom-base w-full rounded-none"
          } ${(isPopoverOpen || isSidebarOpen) && "pointer-events-none"}`}
        >
          {accumulatedData?.length > GlobalConfiguration?.lengthCheckZero &&
            filteredData?.length > GlobalConfiguration?.lengthCheckZero && (
              <>
                <div
                  className={`${
                    (isSidebarOpen || isPopoverOpen || showInnerSearchBar) &&
                    "opacity-light-opacity bg-PopUp-BackDrop h-full"
                  }`}
                >
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={mainData}
                    pageSize={pageSize}
                    dropdownOptions={dropdownOptions}
                    handlePagination={handlePagination}
                    currentPage={currentPage}
                    setIsOpen={setIsOpen}
                    typePopup={typepop === "popup" || type === "activeInactive"}
                  />
                </div>
              </>
            )}
        </div>

        {isLabelPopupOpen && (
          <div className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
            <CommonAssignLabelPopup
              headerTitle="Assign/unassign labels:"
              headersubtext="Labels will be used to generate statistics for the associated accounts."
              closehandleFunction={handleClose}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              LabelAccounts={LabelAccounts}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={[
                ...new Map(
                  accumulatedData.map((item) => [item["id"], item]),
                ).values(),
              ].filter((account) => LabelAccounts.includes(account.id))}
              onClose={handleClose}
              loading={loading}
              setLoading={setLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
            />
          </div>
        )}

        <div
          className={` relative z-z-index-overlay bg-primary-nav ${isSidebarOpen && " fixed  w-full "}`}
        >
          <div className=" ">
            <div
              className={`  ${typepop === "popup" || type === "activeInactive" ? " hidden Qsmd:block" : " hidden Qmd:block h-navbar-breadcrumb-height"}   w-full `}
            ></div>
          </div>
        </div>

        <div
          className={`bene_div_container z-z-index-header Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act ${typepop === "popup" || type === "activeInactive" ? " w-full Qmd:w-full-popup-width" : "w-full-width"} relative `}
        >
          <TopNavComponent
            loading={loading}
            topNavCtaBtn1Needed={false}
            topNavCtaBtn1Props={
              isLabelClicked
                ? {
                    btnText: `${LabelAccounts?.length ? "Clear" : "Cancel"}`,
                    btnType: "button",
                    enabledBgColor: "var(--primary-nav-act)",
                    handleFunction: (e) => {
                      const textContent = e.target.textContent.trim();
                      if (textContent === "Clear") {
                        setLabelAccounts([]);
                      }
                      if (textContent === "Cancel") {
                        setisLabelClicked(false);
                      }
                    },
                    enabledTextColor: "var(--text-primary)",
                    isDisabled: isSidebarOpen || showSearchBar,
                    hoverOption: "white",
                  }
                : undefined
            }
            topNavCtaBtn2Needed={false}
            topNavCtaBtn2Props={
              isLabelClicked
                ? {
                    btnText: "Assign labels",
                    btnType: "button",
                    enabledBgColor: LabelAccounts?.length
                      ? "var(--text-primary)"
                      : "var(--text-disabled)",
                    handleFunction: (e) => {
                      e.stopPropagation();
                      if (LabelAccounts?.length) {
                        setIsLabelPopupOpen(true);
                      }
                    },
                    enabledTextColor: LabelAccounts?.length
                      ? "var(--primary-bg)"
                      : "Var(--text-primary)",
                    isDisabled:
                      isSidebarOpen || showSearchBar || !LabelAccounts?.length,
                    hoverOption: LabelAccounts?.length ? "black" : "white",
                  }
                : undefined
            }
            BottomSubText={
              isLabelClicked
                ? "Select accounts to apply labels. These labels will be used to generate statistics for the associated accounts."
                : undefined
            }
            BottomSubTextVaraint="primary"
            isSelectionView={isLabelClicked && true}
            isToggleNeeded={true}
            toggleProps={
              !isLabelClicked
                ? {
                    state: toggle,
                    title: toggle ? "Grid View" : "List View",
                    isDisabled: isSidebarOpen || showSearchBar,
                    handleClick: () => handleToggle(!toggle),
                  }
                : undefined
            }
            selectionText={`Account selected - ${LabelAccounts?.length || "0"}`}
            selectionBtnProps={
              isLabelClicked
                ? {
                    btnText: "Select all",
                    btnType: "button",
                    enabledBgColor:
                      filteredData.filter(
                        (item) => item?.approval_status !== "archived",
                      )?.length === LabelAccounts?.length &&
                      !!LabelAccounts?.length
                        ? "var(--positive-bg)"
                        : "var(--primary-nav-act)",
                    handleFunction: () => {
                      handleSelectAll();
                    },
                    enabledTextColor: "var(--text-primary)",
                    isDisabled: false,
                    hoverOption:
                      filteredData.filter(
                        (item) => item?.approval_status !== "archived",
                      )?.length === LabelAccounts?.length &&
                      !!LabelAccounts?.length
                        ? "black"
                        : "white",

                    icon:
                      filteredData.filter(
                        (item) => item?.approval_status !== "archived",
                      )?.length === LabelAccounts?.length &&
                      !!LabelAccounts?.length
                        ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                        : ICONS?.SELECT_ALL_WHITE_OUTLINE,
                  }
                : undefined
            }
            assignLabelNeeded={true}
            assignTagNeeded={true}
            assignLabelProps={
              !isLabelClicked
                ? {
                    handleFunction: () => {
                      if (!accumulatedData?.length) return;
                      if (
                        type === "activeInactive" ||
                        typepop === "popup" ||
                        flow === "beneTxn"
                      ) {
                        CommonToast({
                          text: "Action restricted in popup mode.",
                          icon: ICONS?.ERROR_WHITE_CIRCLE,
                          variant: "var(--error)",
                        });
                      } else if (
                        services?.includes("ALabel") &&
                        services?.includes("RLabel")
                      ) {
                        if (isSidebarOpen || showSearchBar) {
                          return;
                        }
                        setisLabelClicked((prev) => {
                          if (prev) {
                            setLabelAccounts([]);
                          }
                          return !prev;
                        });
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "ALabel,RLabel",
                          },
                        });
                      }
                    },
                    isDisabled:
                      !accumulatedData?.length ||
                      type === "activeInactive" ||
                      typepop === "popup" ||
                      isSidebarOpen ||
                      showSearchBar ||
                      flow === "beneTxn",
                    enabledBgColor: "var(--primary-bg)",
                    isLoading: false,

                    hoverOption: "white",
                    buttonRef: null,
                    title:
                      "Labels will be used to generate statistics for the associated accounts",
                  }
                : undefined
            }
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: isSidebarOpen || loading,
              onSearchInput: (val) => handleSearch(val),
              searchText: searchUserTextDebounce,
              searchPlaceholder: subType
                ? "Search reimbursement account"
                : "Search beneficiary account",
              filterPlaceholder:
                "Name / contact number / email ID / account ID",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchUserText,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit("search", val);
                    setSearchUserText(val);
                  },
                  isDropdown: false,
                  isDisabled: loading,
                },
                {
                  name: "Account number",
                  short_name: subType ? "Reimb A/c" : "Bene A/c",
                  isMulti: false,
                  value:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? activeInactiveBank
                      : remAccount !== "" && typepop === "popup"
                        ? remAccount
                        : accountNumber,
                  setValue: (val) => {
                    handleSubmit("accno", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setAccountNumber(val);
                  },
                  isDropdown: false,
                  valueType: "string",
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : remAccount !== "" && typepop === "popup"
                        ? true
                        : false,
                },
                {
                  name: "IFSC code",
                  short_name: "IFSC",
                  isMulti: false,
                  value:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? activeInactiveIfsc
                      : remIFSC !== "" && typepop === "popup"
                        ? remIFSC
                        : isIfsc.toUpperCase(),
                  setValue: (val) => {
                    handleSubmit("ifsc", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setIsIfsc(val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : remIFSC !== "" && typepop === "popup"
                        ? true
                        : false,
                },
                {
                  name: "PAN number",
                  short_name: "PAN",
                  isMulti: false,
                  value:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Pan" ||
                      activeInactiveFlow === "Existing")
                      ? activeInactivePan
                      : remPan !== "" && typepop === "popup"
                        ? remPan
                        : panNumber.toUpperCase(),
                  setValue: (val) => {
                    handleSubmit("pan", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setPanNumber(val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Pan" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : remPan !== "" && typepop === "popup"
                        ? true
                        : false,
                },
                {
                  name: "Category",
                  valueType: "string",
                  short_name: "Cat",
                  isMulti: false,
                  value: currentCategory,
                  setValue: (val) => {
                    handleSubmit("category", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setCurrentCategory(val);
                  },
                  isDropdown: true,
                  isDisabled: loading ? true : false,
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: (val) => {
                    handleSubmit("label", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setLabelSearchText(val);
                  },
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: loading,
                },
              ],
              filters: [
                {
                  name: "Account status",
                  filterType: "dropdown",
                  variant: "single",
                  size: "small",
                  value: currentStatus,
                  dropdownPlaceHolder: "Select status",
                  isDisabled: type === "activeInactive" ? true : false,
                  options: status,
                  statusPop: true,
                  handleChange: (val) => {
                    handleSubmit("status", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setCurrentStatus(val);
                  },
                },
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value:
                    (startDate && endDate) ||
                    (startDateFilter && endDateFilter),
                  isDisable: false,
                  startDate:
                    startDate ||
                    (startDateFilter
                      ? new Date(
                          startDateFilter *
                            IntervalConfiguration.intervalMedium,
                        )
                      : null),
                  endDate:
                    endDate ||
                    (endDateFilter
                      ? new Date(
                          endDateFilter * IntervalConfiguration.intervalMedium,
                        )
                      : null),
                  handleChange: (date) => {
                    handleSubmit("date", date);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleDateChange(date);
                  },
                },
              ],
              isFilterClearAllDisabled: !(
                (startDateFilter && endDateFilter) ||
                currentStatus !== "" ||
                loading
              ),
              isSearchClearAllDisabled:
                type === "activeInactive"
                  ? true
                  : !(
                      accountNumber?.length ||
                      isIfsc?.length ||
                      panNumber?.length ||
                      currentCategory?.length ||
                      LabelSearchText?.length ||
                      searchUserText?.length ||
                      loading
                    ),
              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: loadingData,
              setLoading: setLoadingData,
              isShowSortBy: false,
              isShowFilter: true,
              loading: loading,
              loadingData: loadingData,
              isSortDisabled: loading,
              isFilterDisabled: loading,
            }}
            ispagination={
              accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
                ? false
                : true
            }
          />
        </div>
        {showInnerSearchBar && (
          <div class="absolute bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none w-full h-full z-z-index-content Qsmd:z-z-index-header"></div>
        )}
        {!toggle ? (
          <div
            ref={scrollContainerRef}
            tabIndex="0"
            id={
              typepop === "popup" || type === "activeInactive"
                ? ""
                : "infinityScrollContainerBeneView"
            }
            className={` ${
              accumulatedData?.length === GlobalConfiguration.lengthCheckZero ||
              loading
                ? "pb-bottom-base"
                : isLabelClicked
                  ? "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
                  : "pb-[var(--pagination-height)]"
            } ${showInnerSearchBar ? "bg-PopUp-BackDrop opacity-light-opacity" : ""} ${
              typepop === "popup" || type === "activeInactive"
                ? " h-full flex flex-col flex-1 overflow-hidden min-h-0"
                : "infinityScrollContainerAccBeneView h-height-full flex-1 min-h-0"
            } ${showInnerSearchBar ? "overflow-hidden" : "overflow-y-scroll"}`}
            style={{
              overflow: !isWheelScrolling && "hidden",
              marginBottom: !isWheelScrolling && "var(--margin-base)",
            }}
            onKeyDown={(event) => {
              if (
                event.key === "w" ||
                event.key === "s" ||
                event.key === "W" ||
                event.key === "S" ||
                event.code === "KeyS" ||
                event.code === "KeyW" ||
                event.key === "ArrowUp" ||
                event.key === "ArrowDown"
              ) {
                event.preventDefault();

                return false;
              }
            }}
          >
            {loading ? (
              <div className="flex items-center justify-center w-full h-full flex-1">
                <Loader />
              </div>
            ) : filteredData?.length > GlobalConfiguration.lengthCheckZero ? (
              <div
                style={{
                  scrollPaddingTop: "var(--padding-md)",
                  scrollPaddingBottom: "var(--padding-md)",
                }}
                className={`w-full scroll flex flex-col min-h-0 items-center h-full-height overflow-y-auto ${showInnerSearchBar && "overflow-y-hidden pointer-events-none"} ${isSidebarOpen && "overflow-y-hidden"}`}
                ref={filterRef}
              >
                <BeneAccountGridView
                  filterRef={filterRef}
                  subType={subType}
                  id={id}
                  data={filteredData}
                  lastElementRef={lastElementRef}
                  isSidebarOpen={showInnerSearchBar}
                  typepop={typepop}
                  type={type}
                  handleButtonClick={handleButtonClick}
                  internalAccount={internalAccount}
                  associateaccountNumber={associateaccountNumber}
                  associateAccount={associateAccount}
                  balanceType={balanceType}
                  setOpenBeneAssociate={setOpenBeneAssociate}
                  associatepanNumber={associatepanNumber}
                  showSearchBar={showSearchBar}
                  beneAccountId={beneAccountId}
                  flow={flow}
                  name1={name1}
                  txnPayLoad={txnPayLoad}
                  setTxnPayLoad={setTxnPayLoad}
                  setIsImps={setIsImps}
                  setIsNeft={setIsNeft}
                  onClosepop={onClosepop}
                  setIsRtgs={setIsRtgs}
                  accountType={accountType}
                  BeneTxnAssocAcct={BeneTxnAssocAcct}
                  setAssociateModalOpen={setAssociateModalOpen}
                  associateTxn={associateTxn}
                  type1={"BeneTxnAssoc"}
                  isLabelClicked={isLabelClicked}
                  setLabelAccounts={setLabelAccounts}
                  LabelAccounts={LabelAccounts}
                  isFilterActive={isFilterActive}
                  setlableInput={setlableInput}
                  Labeldata={Labeldata}
                  setLabeldata={setLabeldata}
                  onCardNavigate={onCardNavigate}
                  setIsalertPopup={setIsalertPopup}
                  setFlowSelectedId={setFlowSelectedId}
                  classifiedFlow={classifiedFlow}
                />
              </div>
            ) : accumulatedData?.length ===
                GlobalConfiguration?.lengthCheckZero &&
              filteredData?.length === GlobalConfiguration?.lengthCheckZero &&
              !loading ? (
              <div
                className="flex flex-col items-center justify-center m-auto w-full h-full "
                style={{
                  height:
                    (typepop === "popup" || type === "activeInactive") &&
                    showSearchBar
                      ? " var(--width-full)"
                      : "",
                  overflowY: showSearchBar && "scroll",
                }}
              >
                <img
                  src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                  alt="No accounts found"
                  className={` opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm`}
                />
                <p
                  className={`text-font-sm text-text-primary  items-center font-semibold ${
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing") &&
                    (currentCategory !== "" ||
                      panNumber !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied)
                      ? "mb-margin-sm"
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Pan" ||
                            activeInactiveFlow === "Existing") &&
                          (currentCategory !== "" ||
                            accountNumber !== "" ||
                            isIfsc !== "" ||
                            searchUserText !== "" ||
                            isFilterApplied)
                        ? "mb-margin-sm"
                        : type === "activeInactive"
                          ? "mb-margin-xs"
                          : "mb-margin-sm"
                  }`}
                >
                  {type === "activeInactive" &&
                  accActiveInactiveState === "active"
                    ? "No active associated accounts found."
                    : type === "activeInactive" &&
                        accActiveInactiveState === "inactive"
                      ? "No inactive associated accounts found."
                      : "No data found."}
                </p>
                {type === "activeInactive" && activeInactiveFlow === "Bank" ? (
                  currentCategory !== "" ||
                  panNumber !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearSearchParam();
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active accounts linked to the provided Bank under the beneficiary account classification."
                        : "There are no existing inactive accounts linked to the provided Bank under the beneficiary account classification."}
                    </p>
                  )
                ) : type === "activeInactive" &&
                  activeInactiveFlow === "Pan" ? (
                  currentCategory !== "" ||
                  accountNumber !== "" ||
                  isIfsc !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearSearchParam();
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active accounts linked to the provided PAN under the beneficiary account classification."
                        : "There are no existing inactive accounts linked to the provided PAN under the beneficiary account classification."}
                    </p>
                  )
                ) : (
                  (currentCategory !== "" ||
                    panNumber !== "" ||
                    accountNumber !== "" ||
                    isIfsc !== "" ||
                    searchUserText !== "" ||
                    isFilterApplied) && (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearSearchParam();
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  )
                )}
              </div>
            ) : (
              <div className="loader-container grid place-items-center  Qsmd:absolute w-full h-full">
                <Loader />
              </div>
            )}

            {(currentStatus === "" || currentStatus === "all") && (
              <div ref={lastElementRef}></div>
            )}
          </div>
        ) : (
          <div
            ref={scrollContainerRef}
            tabIndex="0"
            id={
              typepop === "popup" || type === "activeInactive"
                ? ""
                : "infinityScrollContainerBeneView"
            }
            className={` ${
              accumulatedData?.length == GlobalConfiguration.lengthCheckZero ||
              loading
                ? "pb-bottom-base"
                : isLabelClicked
                  ? "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
                  : "pb-[var(--pagination-height)]"
            } ${showInnerSearchBar ? "bg-PopUp-BackDrop opacity-light-opacity" : ""} ${
              typepop === "popup" || type === "activeInactive"
                ? " h-full flex flex-col flex-1 overflow-hidden min-h-0"
                : "infinityScrollContainerAccBeneView h-height-full flex-1 min-h-0"
            } `}
            style={{
              overflow: !isWheelScrolling && "hidden",
              marginBottom: !isWheelScrolling && "var(--margin-base)",
            }}
            onKeyDown={(event) => {
              if (
                event.key === "w" ||
                event.key === "s" ||
                event.key === "W" ||
                event.key === "S" ||
                event.code == "KeyS" ||
                event.code == "KeyW" ||
                event.key === "ArrowUp" ||
                event.key === "ArrowDown"
              ) {
                event.preventDefault();

                return false;
              }
            }}
          >
            {loading ? (
              <div className="loader-container grid place-items-center  Qsmd:absolute w-full h-full">
                <Loader />
              </div>
            ) : filteredData?.length > GlobalConfiguration.lengthCheckZero ? (
              <>
                <div
                  style={{
                    scrollPaddingTop: "var(--padding-md)",
                    scrollPaddingBottom: "var(--padding-md)",
                  }}
                  className={`scroll  flex flex-col min-h-0 items-center h-full-height overflow-y-auto ${showInnerSearchBar && "pointer-events-none"} w-full   ${
                    showInnerSearchBar && "overflow-y-hidden"
                  }`}
                  ref={filterRef}
                >
                  <BeneAccountListView
                    filterRef={filterRef}
                    associateTxn={associateTxn}
                    subType={subType}
                    type={type}
                    data={accumulatedData}
                    isSidebarOpen={showInnerSearchBar}
                    page={currentPage}
                    isPopoverOpen={isPopoverOpen}
                    typepop={typepop}
                    handleButtonClick={handleButtonClick}
                    pageSize={pageSize}
                    internalAccount={internalAccount}
                    associateAccount={associateAccount}
                    balanceType={balanceType}
                    associatepanNumber={associatepanNumber}
                    showSearchBar={showSearchBar}
                    beneAccountId={beneAccountId}
                    txnPayLoad={txnPayLoad}
                    setTxnPayLoad={setTxnPayLoad}
                    setIsNeft={setIsNeft}
                    setIsImps={setIsImps}
                    setIsRtgs={setIsRtgs}
                    onClosepop={onClosepop}
                    flow={flow}
                    accountType={accountType}
                    setOpenBeneAssociate={setOpenBeneAssociate}
                    setAssociateModalOpen={setAssociateModalOpen}
                    BeneTxnAssocAcct={BeneTxnAssocAcct}
                    isLabelClicked={isLabelClicked}
                    setLabelAccounts={setLabelAccounts}
                    LabelAccounts={LabelAccounts}
                    isFilterActive={isFilterActive}
                    setlableInput={setlableInput}
                    Labeldata={Labeldata}
                    setLabeldata={setLabeldata}
                    onCardNavigate={onCardNavigate}
                    setIsalertPopup={setIsalertPopup}
                    setFlowSelectedId={setFlowSelectedId}
                    classifiedFlow={classifiedFlow}
                  />
                </div>
              </>
            ) : accumulatedData?.length ===
                GlobalConfiguration?.lengthCheckZero &&
              filteredData?.length === GlobalConfiguration?.lengthCheckZero &&
              !loading ? (
              <div
                className="flex flex-col items-center justify-center m-auto w-full h-full"
                style={{
                  height:
                    (typepop === "popup" || type === "activeInactive") &&
                    showSearchBar
                      ? "var(--width-full)"
                      : "",
                  overflowY: showSearchBar && "scroll",
                }}
              >
                <img
                  src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                  alt="No accounts found"
                  className={` opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm`}
                />
                <p
                  className={`text-font-sm text-text-primary  items-center font-semibold ${
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing") &&
                    (currentCategory !== "" ||
                      panNumber !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied)
                      ? "mb-margin-sm"
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Pan" ||
                            activeInactiveFlow === "Existing") &&
                          (currentCategory !== "" ||
                            accountNumber !== "" ||
                            isIfsc !== "" ||
                            searchUserText !== "" ||
                            isFilterApplied)
                        ? "mb-margin-sm"
                        : type === "activeInactive"
                          ? "mb-margin-xs"
                          : "mb-margin-sm"
                  }`}
                >
                  {type === "activeInactive" &&
                  accActiveInactiveState === "active"
                    ? "No active associated accounts found."
                    : type === "activeInactive" &&
                        accActiveInactiveState === "inactive"
                      ? "No inactive associated accounts found."
                      : "No data found."}
                </p>

                {type === "activeInactive" && activeInactiveFlow === "Bank" ? (
                  currentCategory !== "" ||
                  panNumber !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearSearchParam();
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active accounts linked to the provided Bank under the beneficiary account classification."
                        : "There are no existing inactive accounts linked to the provided Bank under the beneficiary account classification."}
                    </p>
                  )
                ) : type === "activeInactive" &&
                  activeInactiveFlow === "Pan" ? (
                  currentCategory !== "" ||
                  accountNumber !== "" ||
                  isIfsc !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearSearchParam();
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active accounts linked to the provided PAN under the beneficiary account classification."
                        : "There are no existing inactive accounts linked to the provided PAN under the beneficiary account classification."}
                    </p>
                  )
                ) : (
                  (currentCategory !== "" ||
                    panNumber !== "" ||
                    accountNumber !== "" ||
                    isIfsc !== "" ||
                    searchUserText !== "" ||
                    isFilterApplied) && (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearSearchParam();
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  )
                )}
              </div>
            ) : (
              <div className="loader-container grid place-items-center  Qsmd:absolute w-full h-full">
                <Loader />
              </div>
            )}

            {(currentStatus === "" || currentStatus === "all") && (
              <div ref={lastElementRef}></div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default BeneficiaryAccountViewAll;
